import React from "react";

const ThankYou: React.FC = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>Dziękujemy za przygotowanie projektu!</h1>
      <p>
        Twój projekt został pomyślnie wygenerowany. Teraz zabieramy się za druk
        najszybciej jak to możliwe. <br />
        Sprawdzimy wszystko dokładnie i damy znać, gdy Twoje zamówienie będzie
        gotowe do odbioru!
      </p>
      <p>Dziękujemy za zaufanie!</p>
    </div>
  );
};

export default ThankYou;
